<template>
  <div class="window">
    <div class="bg">
      <div class="layer-0"></div>
      <div class="layer-1"></div>
    </div>
    <div class="login">
      <p class="page-title">
        登录<span>{{ title }}</span>
      </p>
      <div class="info">
        <p class="name">{{ copyright.system_name }}</p>
        <p class="name">{{ copyright.system_name_en }}</p>
        <p class="version">{{ version.full_verison }}</p>
      </div>
      <van-tabs class="method-navs" v-model="active" line-width="12rem">
        <van-tab title="用户账号" :name="1"></van-tab>
        <van-tab title="手机登录" :name="2"></van-tab>
      </van-tabs>
      <template v-if="active === 1">
        <div class="field-item">
          <p class="title">
            账号
          </p>
          <van-field
            v-model="username"
          />
        </div>
        <div class="field-item">
          <p class="title">
            密码
          </p>
          <van-field
            v-model="password"
            type="password"
          />
        </div>
        <div class="check-item">
          <van-checkbox
            v-model="rememberMe"
            shape="square"
            checked-color="#09B9B0"
          >记住账号</van-checkbox>
        </div>
      </template>
      <template v-if="active === 2">
        <div class="phone-field-item">
          <span class="label">+ 86</span>
          <van-field
            v-model="phone"
            placeholder="请输入手机号"
            :maxlength="11"
          />
        </div>

        <div class="phone-field-item">
          <span class="label">验证码</span>
          <div class="verify-field">
            <van-field
              v-model="verfifyCode"
              placeholder="请输入验证码"
              :maxlength="8"
            />
            <span v-show="timer.count && timer.count >= 0" class="count">
              {{ timer.count }}S
            </span>
          </div>
          <span
            class="verify-send-btn"
            :class="{ 'disabled' : timer.count > 0 }"
            @click="sendVerify()"
          >
            发送验证码
          </span>
        </div>

        <div class="fill-div"></div>
      </template>
      <div class="main-btn">
        <van-button
          @click="handleLogin"
        >登录</van-button>
      </div>
      <div class="privacy-and-agreement">
        <van-checkbox
          v-model="agreePolicy"
          checked-color="#09B9B0"
        >阅读并同意</van-checkbox>
        <span
          class="link"
         @click="$utils.app.openUrl(`${productionHost}/agreement`)">
          《服务协议》
        </span>
        和
        <span
          class="link"
          @click="$utils.app.openUrl(`${productionHost}/privacy`)">
          《隐私政策》
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex';
import {
  login,
  fetchVerify,
  loginByVerify
} from '@/api/login';
import {
  userTokenKey,
  productionHost
} from '@/config/index';

export default {
  name: 'Login',
  data() {
    return {
      active: 1,
      username: '',
      password: '',
      rememberMe: false,
      phone: '',
      verfifyCode: '',
      timer: {
        timer: null,
        total: 60,
        count: 0
      },
      agreePolicy: false,
      productionHost,
      title : ''
    }
  },
  created() {
    const { NODE_ENV } = process.env
    if (NODE_ENV == 'test') {
      this.title = '（测试版）'
    }
  },
  computed: {
    ...mapGetters(['copyright', 'version'])
  },
  methods: {
    handleLogin() {
      const { active, agreePolicy } = this
      if (!agreePolicy) {
        this.$Toast.fail('请选阅读并同意《服务协议》和《隐私政策》')

        return
      }
      if (active === 1) {
        this.accountLogin()
      } else if (active === 2) {
        this.verfifyLogin()
      }
    },
    accountLogin() {
      const params = {
        username: this.username,
        password: this.password
      }

      login(params)
      .then(res => {
        if (res) {
          const {
            token
          } = res

          const expires = this.rememberMe ? 
          30 : 
          this.$moment().subtract(-1, 'days').startOf('day').toDate()

          this.$cookie.set(userTokenKey, token, { expires })
          window.location.replace('/index')
        }
      })
    },
    verfifyLogin() {
      const {
        phone,
        verfifyCode
      } = this

      if (!phone || phone.length !== 11) {
        this.$Toast.fail('请输入正确的手机号')
        return
      }

      if (!verfifyCode) {
        this.$Toast.fail('请填写验证码')
        return
      }

      const params = {
        mobile: phone,
        sms_verify_code: verfifyCode
      }

      loginByVerify(params)
      .then(res => {
        if (res) {
          const {
            token
          } = res
          const expires = this.$moment().subtract(-1, 'days').startOf('day').toDate();

          this.$cookie.set(userTokenKey, token, { expires })
          window.location.replace('/index')
        }
      })
    },
    sendVerify() {
      if (this.timer.count > 0) return

      const {
        phone
      } = this

      if (!phone || phone.length !== 11) {
        this.$Toast.fail('请输入正确的手机号')
        return
      }

      fetchVerify({ mobile: phone })
      .then(res => {
        if (res) {
          const {
            ttl	
          } = res

          this.$Toast.success('发送成功，请查收')

          this.startTimer(ttl)
        }
      })
    },
    stopTimer() {
      if (this.timer.timer) {
        clearInterval(this.timer.timer)
      }

      this.timer.total = 0
      this.timer.timer = null
    },
    startTimer(duration = 10) {
      this.timer.count = duration
      this.timer.timer = this.timer.timer || setInterval(() => {
        this.timer.count -= 1
        if (this.timer.count < 0) {
          this.stopTimer()
        }
      }, 1000)
    },
  }
}
</script>

<style lang="less" scoped>
  @import '~@/assets/style/index.less';
  .window {
    height: 100vh;
    width: 100vw;
    position: relative;
    .bg {
      position: absolute;
      width: 100%;
      top: 0;
      z-index: 1;
      .layer-0 {
        width: 100%;
        height: 812px;
        background-image: linear-gradient(to bottom, #44D0C9, #2B71FE);
      }
      .layer-1 {
        width: 100%;
        height: 812px;
        background-image: linear-gradient(to bottom, #2B71FE, #FFF);
      }
    }
    .login {
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      z-index: 2;
      .page-title {
        font-size: 60px;
        text-align: center;
        font-weight: bold;
        color: #fff;
        margin: 246px 0 102px;
      }
      .info {
        font-size: 36px;
        .name, .version {
          text-align: center;
          line-height: 46px;
        }
        .name {
          color: #fff;
        }
        .version {
          color: #A0A0A0;
        }
      }

      .field-item {
        padding: 0 150px;
        margin: 0 0 66px 0;
        .title {
          font-size: 46px;
          color: #fff;
        }
        .van-cell {
          padding: 8px 16px;
          margin: 12px 0;
        }
        .van-field {
          border-radius: 4px;
          background-color: rgba(255, 255, 255, 0.3);
          /deep/ input {
            color: #fff;
          }
        }
      }

      .phone-field-item {
        padding: 0 150px;
        display: flex;
        margin: 0 0 26px 0;
        .label {
          width: 140px;
          height: 126px;
          line-height: 126px;
          color: #fff;
          font-size: 46px;
          text-align: right;
          margin: 0 22px 0 0;
        }
        .verify-send-btn {
          height: 126px;
          line-height: 126px;
          margin: 0 0 0 22px;
          font-size: 46px;
          color: #02FCEF;
          &.disabled {
            color: rgba(255, 255, 255, 0.5);
          }
        }
        .van-cell {
          flex: 1;
          padding: 10px 16px;
          &::after {
            border: none;
          }
        }
        .van-field {
          border-radius: 4px;
          background-color: rgba(255, 255, 255, 0.3);
          /deep/ input {
            color: #fff;
            &::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
        .verify-field {
          position: relative;
          flex: 1;
          .count {
            position: absolute;
            right: 10px;
            top: 30px;
            font-size: 46px;
            color: #fff;
          }
        }
      }

      .fill-div {
        height: 256px;
      }

      .check-item {
        padding: 0 150px;
        /deep/ .van-checkbox__label {
          font-size: 46px;
          color: #fff;
        }
        /deep/ .van-checkbox__icon {
          .van-icon {
            border-color: #fff;
            // color: @primary-color;
          }
        }
      }

      .main-btn {
        padding: 0 150px;
        margin: 14px 0 0;
        .van-button {
          width: 100%;
          height: 126px;
          background-image: linear-gradient(135deg, @primary-color-3, @primary-color-4);
          color: #fff;
          border-radius: 4px;
          font-size: 52px;
          font-weight: bold;
          border: none;
        }
      }

      .privacy-and-agreement {
        padding: 0 150px;
        margin: 20px auto;
        font-size: 36px;
        color: @primary-font-color;
        display: flex;
        .van-checkbox {
          margin: 0 6px 0 0;
        }
        /deep/ .van-checkbox__label {
          color: @primary-font-color;
        }
        .link {
          color: @primary-color-1;
        }
      }

      .method-navs {
        padding: 0 150px;
        margin: 100px 0 102px;
        /deep/ .van-tab {
          flex: none !important;
          margin: 0 0 0 100px;
          padding: 0;
          &:first-child {
            margin: 0 !important;
          }
        }
        /deep/ .van-tab__text {
          font-size: 52px;
          color: rgba(255, 255, 255, 0.5);
        }
        /deep/ .van-tab--active {
          .van-tab__text {
            color: #fff;
          }
        }
        /deep/ .van-tabs__line {
          background-color: @primary-color-1;
        }
      }
    }
  }
</style>